import type { ReactNode } from 'react'

export interface PageHeaderProps {
  title: ReactNode
  caption?: ReactNode
  /** Avatar/icon rendered left of the title block — detail pages only. */
  icon?: ReactNode
  /** Right-hand slot, e.g. PageSaveDiscardActions or a view toggle. */
  actions?: ReactNode
  /** 'overview' (default) is the `.global-settings-header` row used by every
      list/overview page; 'detail' is the `.sparks-main-header` row (avatar +
      title/caption on the left) used by Agent/MCP/MCP Analytics detail pages. */
  variant?: 'overview' | 'detail'
}

export function PageHeader({
  title,
  caption,
  icon,
  actions,
  variant = 'overview',
}: Readonly<PageHeaderProps>) {
  if (variant === 'detail') {
    return (
      <div className="sparks-main-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, minWidth: 0 }}>
          {icon}
          <div style={{ minWidth: 0 }}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>{title}</h2>
            {caption && <p>{caption}</p>}
          </div>
        </div>
        {actions && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
            {actions}
          </div>
        )}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
      <div className="global-settings-header">
        <h2>{title}</h2>
        {caption && <p>{caption}</p>}
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {actions}
        </div>
      )}
    </div>
  )
}
